import { useEffect, useState } from 'react';

export const isMobileUserAgent = (userAgent?: string) => {
  const ua = userAgent || navigator.userAgent || '';

  return Boolean(ua.match(/Android|iPhone|iPad|iPod|Opera Mini|IEMobile|SSR/i));
};

export const useIsMobileUserAgent = () => {
  const [flag, setFlag] = useState(false);

  useEffect(() => {
    const isMobile = isMobileUserAgent();

    setFlag(isMobile);
  }, []);

  return flag;
};
